module.exports = __webpack_public_path__ + "static/fabric-shimmer-elements-group-15a62aa87903fccb19c37cd3040acc48.png";